export default __webpack_public_path__ + "static/media/Q22019.97e1fa40.PDF";